import React from "react";
import styled from "styled-components";
import { getCities } from "../../../../../api/address";

const ListWrapper = styled.ul`
  list-style: none;
  max-height: 150px;
  overflow-y: scroll;
  position: absolute;
  z-index: 1000;
  width: 100%;
  margin-top: 4px;
  padding: 0;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  border-radius: 8px;
`;

const ListItem = styled.li`
  background-color: #fff;
  padding: 10px 16px;
  border-bottom: 1px solid #f1f3f5;
  cursor: pointer;
  font-size: 0.95rem;
  color: #495057;
  transition: all 0.2s ease;
  
  &:last-child {
    border-bottom: none;
  }
  
  &:hover {
    background-color: #f8f9fa;
    color: #0088cc;
  }
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;

const ufCodeToAcronym = {
  "11": "RO", "12": "AC", "13": "AM", "14": "RR", "15": "PA", "16": "AP", "17": "TO",
  "21": "MA", "22": "PI", "23": "CE", "24": "RN", "25": "PB", "26": "PE", "27": "AL",
  "28": "SE", "29": "BA", "31": "MG", "32": "ES", "33": "RJ", "35": "SP", "41": "PR",
  "42": "SC", "43": "RS", "50": "MS", "51": "MT", "52": "GO", "53": "DF"
};

export default function CityAutocomplete(props) {
  const [input, setInput] = React.useState("");
  const [loading, setLoading] = React.useState(false);
  const [cities, setCities] = React.useState([]);

  // Se receber valor default por props
  React.useEffect(() => {
    if (props.value && !input) {
      setInput(props.value);
    }
  }, [props.value]);

  function onSearch(value) {
    if (value.length >= 4) {
      setLoading(true);
      // Busca a cidade. O endpoint retorna a lista filtrada pelo nome
      getCities({ city: value })
        .then((data) => {
          setCities(data);
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
        });
    } else {
      setCities([]);
    }
  }

  function onChange(e) {
    const { value } = e.target;
    setInput(value);
    
    // Dispara a busca quando houver 4 ou mais caracteres
    if (value.length >= 4 || e.key === "Enter") {
      setTimeout(() => onSearch(value), 300);
    } else {
      setCities([]);
    }
    
    // Se o usuário limpar, limpa o código no form original também
    if (value.trim() === "" && props.onChange) {
      props.onChange({ target: { name: props.name || "city_code_provider", value: "" } });
    }
  }

  function onSelectCity(city) {
    if (props.onChange) {
      // Retorna o ibge_code da cidade, que é o que a NFS-e espera
      props.onChange({ target: { name: props.name || "city_code_provider", value: city.ibge_code } });
    }
    setInput(`${city.city_name} (${city.ibge_code})`);
    setCities([]);
  }

  return (
    <InputWrapper>
      <div style={{ position: 'relative' }}>
        <input
          className={props.className}
          style={props.style}
          name={props.name || "city_code_provider_text"}
          placeholder={props.placeholder || "Digite o nome da cidade"}
          onChange={onChange}
          value={input}
          autoComplete="off"
        />
        {loading && (
          <i 
            className="fas fa-spinner fa-spin text-info" 
            style={{ position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)' }}
          ></i>
        )}
      </div>
      
      {cities && cities.length > 0 && (
        <ListWrapper>
          {cities.map((city) => {
            const stateAcronym = ufCodeToAcronym[city.uf_code] || city.uf_code;
            return (
              <ListItem
                onClick={() => onSelectCity(city)}
                key={city.id}
              >
                <strong>{city.city_name} - {stateAcronym}</strong> <span style={{color: '#868e96', fontSize: '0.85em'}}>- IBGE: {city.ibge_code}</span>
              </ListItem>
            );
          })}
        </ListWrapper>
      )}
    </InputWrapper>
  );
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFSe/emit/components/CityAutocomplete.jsx